import { Component } from 'Shared/frontend/widgets/Component';
import { StylesProvider, IStyleDetails, useStylePath, useStyleDetails } from 'Shared/frontend/widgets/StylesProvider';
import { siteTheme } from 'Shared/frontend/SettingsProvider';
import { createCssFromSettings } from 'Shared/frontend/widgets/createCssFromSettings';


export function Styles(P: {styles:{category:string,type:string,params?:any}[],removeStyles:{category:string,type:string}[],classes:string[]})
{
	const path = useStylePath();

	const parentStyles = useStyleDetails();

	/* Add new styles. We prepend the current path to their location expressions. */
	const calcStyles = () => {
		const flatPath = path.map(e => e.key);

		const trimmedParent = parentStyles().filter(e =>
			!(P.removeStyles ?? []).some(r => r.category === e.category && r.type === e.tag)
		);
		const styleDetails = resolveStyleDetails(flatPath,P.styles);

		return [...trimmedParent, ...styleDetails] as IStyleDetails[];
	};

	return (
		<StylesProvider path={path} styleDetails={calcStyles}> 
			<Component {...P.content} />
		</StylesProvider>
	);
}

export function resolveField(value, params, atTop: boolean)
{
	return typeof value === 'function' ? value(params, atTop) : value;
}

export function applyRule(rule, params: any, atTop: boolean, css: any, settings: any)
{
	const ruleCss = {...resolveField(rule.css, params, atTop)};
	const ruleSettings = {};
	for (const [fieldName, fieldValue] of Object.entries(rule)) {
		const value = resolveField(fieldValue, params, atTop);
		if (value !== undefined)
			createCssFromSettings(fieldName, value, ruleCss, ruleSettings);
	}
	Object.assign(css, ruleCss);
	Object.assign(settings, ruleSettings);
}

export function resolveStyleDetails(flatPath, styles:{category:string,type:string,params?:any}[]): IStyleDetails[]
{
	const styleDetails: IStyleDetails[] = [];

	for (const style of styles ?? []) {
		const styleDef = siteTheme().styles[style.category]?.[style.type];
		if (!styleDef)
			log.warn(`Style not found: ${style.category}/${style.type}`)

		const params = style.params;
		const resolved = [];

		for (const rule of styleDef?.rules ?? []) {
			const location = resolveField(rule.location, params, false);
			const css = {...resolveField(rule.css, params, false)};
			const settings = {};

			for (const [fieldName, fieldValue] of Object.entries(rule)) {
				const value = resolveField(fieldValue, params, false);
				if (value !== undefined)
					createCssFromSettings(fieldName, value, /*mod*/css, /*mod*/settings);
			}

			resolved.push({location, settings, css});
		}
		styleDetails.push({category: style.category, tag: style.type, pathWhenAdded: flatPath, params, rules: resolved});
	}
	return styleDetails;
}

